import React from 'react'
import PropTypes from 'prop-types'
import { Button, Form, Input, Table, Typography, notification } from 'antd';
import leadingZeroes from 'leading-zeroes';
import { appConstant } from 'Util/constants';
import { useMutation, useSubscription } from '@apollo/client';
import { SUB_ADMIN_MODULE } from 'Util/subscriptions';

function AdminModuleList({ onEdit }) {

    const { data, loading } = useSubscription(SUB_ADMIN_MODULE);

    const edit = (record) => {
        onEdit(record)
    };

    const cancel = () => {
    };

    const columns = [
        {
            title: 'Module',
            dataIndex: 'name',
            editable: true,
        },
        {
            title: 'Type',
            dataIndex: 'type',
            editable: true,
        },
        {
            title: 'Description',
            dataIndex: 'description',
            editable: true,
        },
        {
            title: 'Actions',
            width: '120px',
            dataIndex: 'action',
            render: (_, record) => (
                <Typography.Link onClick={() => edit(record)}>
                    Edit
                </Typography.Link>
            ),
        },
    ];


    const dataSource = () => {

        if (data) {

            return data.admin_modules.map((v, i) => (
                {
                    key: `key-${i}-admin-module-list`,
                    id: v.id,
                    name: v.name,
                    description: v.description,
                    type: v.type
                }
            ))
        }

        return []

    }

    return (
        <div className='admin-user-list'>
            <Table
                loading={loading}
                bordered
                dataSource={dataSource()}
                columns={columns}
                rowClassName="editable-row"
                pagination={{
                    onChange: cancel,
                    pageSize: 100
                }}
            />
        </div>
    )
}

AdminModuleList.propTypes = {

}

export default AdminModuleList